// @flow
import getDayjsInstance from './getDayjsInstance';

const createInstanceAndAdd = (value: number, unit: string) =>
  getDayjsInstance().add(value, unit);

const getDateFromNow = (value: number, unit: string, format: ?string) =>
  format
    ? createInstanceAndAdd(value, unit).format(format)
    : createInstanceAndAdd(value, unit);

export default getDateFromNow;
